// extracted by css-extract-rspack-plugin
export default {"root":"root-IMs1Sy","checkbox":"checkbox-sp_9ME","primary":"primary-BgUwak","secondary":"secondary-NYb3JN","indicator":"indicator-MSFpig","checkIcon":"checkIcon-UKSqiH"};